import React from "react";
import useElements from "../hooks/useElements";

const BackgroundContainer = (props) => {
  const { value: initValue, className, children, withOverlay = false } = props;
  const { base } = useElements();
  const Head = base?.Head;
  const src = typeof initValue === "string" ? initValue : "";
  const imageSrc =
    initValue?.desktop?.src || initValue?.image?.src || initValue?.url || src;

  const isVisible = true;

  return (
    <div
      className={className}
      style={{
        position: withOverlay && "relative",
        backgroundImage:
          isVisible && imageSrc ? `url('${imageSrc}')` : undefined,
        backgroundPosition: "center center",
        backgroundSize: "cover",
      }}
    >
      <Head>
        <link
          key={"__nimg-" + imageSrc}
          rel="preload"
          as="image"
          href={imageSrc}
        />
      </Head>
      {withOverlay && (
        <div
          style={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0 }}
          className={withOverlay}
        />
      )}
      {withOverlay ? (
        <div style={{ position: "relative" }}>{children}</div>
      ) : (
        children
      )}
    </div>
  );
};

export default BackgroundContainer;
